import * as React from "react";
import { useRouter } from "../../helpers/router/use-router.mjs";
const Anchor = React.forwardRef(function Anchor2(props, ref) {
  const {
    children,
    url,
    id,
    className,
    onClick: propOnClick,
    target,
    isTextColor,
    isUnderlined = true,
    attributes,
    color,
    external = false,
    tabIndex,
    theme,
    ...rest
  } = props;
  const { navigate } = useRouter({ onClick: propOnClick });
  const BEM = () => {
    const classArray = ["anchor"];
    if (color) {
      classArray.push("anchor--" + color);
    }
    if (isTextColor) {
      classArray.push("is-text-color");
    }
    if (isUnderlined) {
      classArray.push("is-underlined");
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const handleClick = (event) => {
    event.stopPropagation();
    if (!external) {
      if (!event.defaultPrevented) {
        navigate(event);
      }
    }
  };
  return /* @__PURE__ */ React.createElement("a", { ...attributes, href: url, className: BEM(), onClick: handleClick, id, target, ref, tabIndex, ...rest, "data-theme": theme }, children);
});
export {
  Anchor
};
